import { window } from '../window.js';
import { HTMLControl } from './html_control.js';

/**
 * Multiline editable text.
 **/
class EditableText extends HTMLControl {
  static properties = {
    readonly: {
      initialize: true,
      attribute: 'boolean',
      set(v) {
        return (this.contentEditable = !v);
      },
    },
    value: {
      get() {
        return this.textContent;
      },
      set(v) {
        this.textContent = v;
      },
    },
  };

  select() {
    window.getSelection().selectAllChildren(this);
  }

  initialize() {
    this.classList.add('text', 'light-grouping');
    super.initialize();

    this.addEventListener('blur', () => {
      let v = this.value;
      if (v != this.valueCached) {
        this.dispatchEvent(
          new CustomEvent('valuechange', {
            detail: v,
          })
        );
        this.valueCached = v;
      }
    });
  }
}

window.customElements.define('editable-text', EditableText);

export { EditableText };
